import { ECountries, ELocales, EZoneCodes, TCountryConfig } from '@/_types';

export const COUNTRY_SELECT_VALUES = {
  ruShort: 'RU',
  ru: 'Россия',
  zh: '中国',
  other: 'Other countries',
  ge: 'საქართველო',
  tr: 'Türkiye',
  byShort: 'BY',
  by: 'Беларусь',
  kz: 'Қазақстан',
  tj: 'Тоҷикистон',
};

export const COUNTRIES_CONFIG: Record<string, TCountryConfig> = {
  [ECountries.RU]: {
    defaultLanguage: ELocales.RU,
  },
  [ECountries.EN]: {
    defaultLanguage: ELocales.EN,
  },
  [ECountries.GE]: {
    defaultLanguage: ELocales.KA,
  },
  [ECountries.ZH]: {
    defaultLanguage: ELocales.ZH,
  },
  [ECountries.TR]: {
    defaultLanguage: ELocales.TR,
  },
  [ECountries.BY]: {
    defaultLanguage: ELocales.RU,
  },
  [ECountries.TJ]: {
    defaultLanguage: ELocales.TG,
  },
  [ECountries.KZ]: {
    defaultLanguage: ELocales.KK,
  },
};

export const ZONE_ALLOWED_COUNTRIES: Record<EZoneCodes, Array<ECountries>> = {
  [EZoneCodes.RU]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.BY]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.CN]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.GE]: [
    ECountries.GE,
    ECountries.RU,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.TR]: [ECountries.TR],
  [EZoneCodes.TJ]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.ET]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.KG]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.AM]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.KZ]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
  [EZoneCodes.UZ]: [
    ECountries.RU,
    ECountries.GE,
    ECountries.EN,
    ECountries.ZH,
    ECountries.BY,
    ECountries.KZ,
    ECountries.TJ,
  ],
};

export const DEFAULT_REDIRECT_BY_ZONE: Record<
  EZoneCodes,
  { country: ECountries; locale: ELocales }
> = {
  [EZoneCodes.RU]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.BY]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.CN]: { country: ECountries.RU, locale: ELocales.RU },
  [EZoneCodes.GE]: { country: ECountries.GE, locale: ELocales.KA },
  [EZoneCodes.TR]: { country: ECountries.TR, locale: ELocales.TR },
  [EZoneCodes.TJ]: { country: ECountries.TJ, locale: ELocales.TG },
  [EZoneCodes.ET]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.KG]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.AM]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.KZ]: { country: ECountries.EN, locale: ELocales.EN },
  [EZoneCodes.UZ]: { country: ECountries.EN, locale: ELocales.EN },
};

export const COUNTRY_ALLOWED_LOCALE: Partial<
  Record<ECountries, Array<ELocales>>
> = {
  [ECountries.RU]: [ELocales.RU, ELocales.EN],
  [ECountries.EN]: [ELocales.RU, ELocales.EN],
  [ECountries.BY]: [ELocales.RU, ELocales.EN],
  [ECountries.ZH]: [ELocales.ZH],
  [ECountries.CN]: [ELocales.ZH],
  [ECountries.GE]: [ELocales.RU, ELocales.EN, ELocales.KA],
  [ECountries.TR]: [ELocales.TR],
  [ECountries.KZ]: [ELocales.RU, ELocales.EN, ELocales.KK],
  [ECountries.TJ]: [ELocales.TG, ELocales.RU, ELocales.EN],
};
